/* AvéliQ — shared theme behaviours (vanilla port of the design prototype).
   Everything is idempotent and re-runs on shopify:section:load so the
   theme editor stays live. */
(function () {
  'use strict';

  /* ---------- scroll progress bar ---------- */
  function onScrollProgress() {
    var de = document.documentElement;
    var sc = window.scrollY || de.scrollTop || 0;
    var max = (de.scrollHeight - de.clientHeight) || 1;
    var bar = document.getElementById('aq-progress');
    if (bar) bar.style.width = (100 * Math.min(1, sc / max)) + '%';
  }
  window.addEventListener('scroll', onScrollProgress, { passive: true });
  window.addEventListener('resize', onScrollProgress);

  /* ---------- header solid state + mobile drawer ---------- */
  function initHeader(root) {
    var hdr = (root || document).querySelector('.hdr');
    if (!hdr || hdr.dataset.aqInit) return;
    hdr.dataset.aqInit = '1';
    var setSolid = function () {
      hdr.classList.toggle('solid', window.scrollY > 40 || hdr.classList.contains('menu-open'));
    };
    window.addEventListener('scroll', setSolid, { passive: true });
    setSolid();
    var burger = hdr.querySelector('.hdr__burger');
    var drawer = hdr.querySelector('.hdr__drawer');
    if (burger && drawer) {
      burger.addEventListener('click', function () {
        var open = !drawer.classList.contains('open');
        drawer.classList.toggle('open', open);
        hdr.classList.toggle('menu-open', open);
        burger.setAttribute('aria-expanded', open);
        document.body.style.overflow = open ? 'hidden' : '';
        var icons = burger.querySelectorAll('svg');
        if (icons.length === 2) {
          icons[0].style.display = open ? 'none' : '';
          icons[1].style.display = open ? '' : 'none';
        }
        setSolid();
      });
      drawer.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          drawer.classList.remove('open');
          hdr.classList.remove('menu-open');
          document.body.style.overflow = '';
        });
      });
    }
  }

  /* ---------- reveal on scroll ---------- */
  var revealIO = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.reveal:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); revealIO.unobserve(e.target); }
        });
      }, { threshold: 0.14 });
    }
    els.forEach(function (el) {
      revealIO.observe(el);
      /* fail-open: never leave content hidden */
      setTimeout(function () { el.classList.add('in'); }, 2600);
    });
  }

  /* ---------- in-view class toggles (slideben, system) ---------- */
  function initInView(root) {
    (root || document).querySelectorAll('[data-aq-inview]').forEach(function (el) {
      if (el.dataset.aqIvInit) return;
      el.dataset.aqIvInit = '1';
      var thr = parseFloat(el.dataset.aqInview) || 0.2;
      if (!('IntersectionObserver' in window)) { el.classList.add('in'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { el.classList.add('in'); io.disconnect(); }
        });
      }, { threshold: Math.min(thr, 0.6) });
      io.observe(el);
      setTimeout(function () { el.classList.add('in'); }, 3200);
    });
  }

  /* ---------- count-up ---------- */
  function initCountUp(root) {
    (root || document).querySelectorAll('[data-countup]').forEach(function (el) {
      if (el.dataset.aqCuInit) return;
      el.dataset.aqCuInit = '1';
      var to = parseFloat(el.dataset.countup) || 0;
      var suffix = el.dataset.suffix || '';
      var dur = 1400;
      var run = function () {
        var t0 = performance.now();
        var tick = function (t) {
          var p = Math.min(1, (t - t0) / dur);
          el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3))) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      };
      if (!('IntersectionObserver' in window)) { el.textContent = to + suffix; return; }
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); run(); }
      }, { threshold: 0.5 });
      io.observe(el);
    });
  }

  /* ---------- before / after slider ---------- */
  function initBeforeAfter(root) {
    (root || document).querySelectorAll('.ba').forEach(function (ba) {
      if (ba.dataset.aqBaInit) return;
      ba.dataset.aqBaInit = '1';
      var before = ba.querySelector('.ba__before');
      var handle = ba.querySelector('.ba__handle');
      var dragging = false;
      var move = function (clientX) {
        var r = ba.getBoundingClientRect();
        var pos = Math.max(3, Math.min(97, (clientX - r.left) / r.width * 100));
        if (before) before.style.clipPath = 'inset(0 ' + (100 - pos) + '% 0 0)';
        if (handle) handle.style.left = pos + '%';
      };
      ba.addEventListener('pointerdown', function (e) { dragging = true; move(e.clientX); });
      window.addEventListener('pointermove', function (e) { if (dragging) move(e.clientX); });
      window.addEventListener('pointerup', function () { dragging = false; });
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initAccordion(root) {
    (root || document).querySelectorAll('.acc').forEach(function (acc) {
      if (acc.dataset.aqAccInit) return;
      acc.dataset.aqAccInit = '1';
      acc.querySelectorAll('.accrow').forEach(function (row) {
        var btn = row.querySelector('.accq');
        var panel = row.querySelector('.acca');
        var inner = panel && panel.firstElementChild;
        if (!btn || !panel) return;
        btn.addEventListener('click', function () {
          var isOpen = row.classList.contains('open');
          acc.querySelectorAll('.accrow.open').forEach(function (r) {
            r.classList.remove('open');
            var p = r.querySelector('.acca');
            if (p) p.style.maxHeight = '0px';
            var b = r.querySelector('.accq');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) {
            row.classList.add('open');
            panel.style.maxHeight = (inner ? inner.scrollHeight : panel.scrollHeight) + 'px';
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
      /* open the first row by default */
      var first = acc.querySelector('.accrow');
      if (first && !acc.querySelector('.accrow.open')) {
        var b = first.querySelector('.accq');
        if (b) b.click();
      }
    });
  }

  /* ---------- product gallery (stage + thumbs) ---------- */
  function initGallery(root) {
    (root || document).querySelectorAll('[data-aq-gallery]').forEach(function (g) {
      if (g.dataset.aqGalInit) return;
      g.dataset.aqGalInit = '1';
      var stage = g.querySelector('.pp-stage__img, .pdp__media img.main');
      g.querySelectorAll('[data-aq-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!stage) return;
          var src = thumb.dataset.aqThumb;
          var srcset = thumb.dataset.aqThumbSrcset || '';
          if (stage.src !== src) {
            stage.style.animation = 'none';
            void stage.offsetWidth; /* restart the fade */
            stage.style.animation = '';
            stage.src = src;
            if (srcset) stage.srcset = srcset; else stage.removeAttribute('srcset');
          }
          g.querySelectorAll('[data-aq-thumb]').forEach(function (t) { t.classList.remove('on'); });
          thumb.classList.add('on');
        });
      });
    });
  }

  /* ---------- simple variant chips (homepage featured product) ---------- */
  function initVariantChips(root) {
    (root || document).querySelectorAll('[data-aq-variants]').forEach(function (box) {
      if (box.dataset.aqVarInit) return;
      box.dataset.aqVarInit = '1';
      var scope = box.closest('[data-aq-product]') || document;
      var idInput = scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"], form input[name="id"]');
      var priceEl = scope.querySelector('[data-aq-price]');
      box.querySelectorAll('button[data-variant-id]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          box.querySelectorAll('button[data-variant-id]').forEach(function (c) { c.classList.remove('on'); });
          chip.classList.add('on');
          if (idInput) idInput.value = chip.dataset.variantId;
          if (priceEl && chip.dataset.price) priceEl.textContent = chip.dataset.price;
          var img = chip.dataset.image;
          if (img) {
            var stage = scope.querySelector('.pdp__media img.main');
            if (stage) stage.src = img;
          }
        });
      });
    });
  }

  /* ---------- collection card style toggle (editorial / minimal) ---------- */
  function initStyleToggle(root) {
    (root || document).querySelectorAll('[data-aq-style-toggle]').forEach(function (tg) {
      if (tg.dataset.aqStInit) return;
      tg.dataset.aqStInit = '1';
      var apply = function (style) {
        document.querySelectorAll('.cl-grid').forEach(function (grid) {
          grid.classList.remove('cl-grid--editorial', 'cl-grid--minimal');
          grid.classList.add('cl-grid--' + style);
          grid.querySelectorAll('.pcard').forEach(function (card) {
            card.classList.remove('pcard--editorial', 'pcard--minimal');
            card.classList.add('pcard--' + style);
          });
        });
        tg.querySelectorAll('.cl-style__b').forEach(function (b) {
          b.classList.toggle('on', b.dataset.style === style);
        });
        try { localStorage.setItem('aq-cl-style', style); } catch (e) {}
      };
      tg.querySelectorAll('.cl-style__b').forEach(function (b) {
        b.addEventListener('click', function () { apply(b.dataset.style); });
      });
      var saved = null;
      try { saved = localStorage.getItem('aq-cl-style'); } catch (e) {}
      if (saved && (saved === 'editorial' || saved === 'minimal')) apply(saved);
    });
  }

  /* ---------- boot ---------- */
  function initAll(root) {
    initHeader(root);
    initReveal(root);
    initInView(root);
    initCountUp(root);
    initBeforeAfter(root);
    initAccordion(root);
    initGallery(root);
    initVariantChips(root);
    initStyleToggle(root);
    onScrollProgress();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* theme editor + facet re-renders */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  /* facets.js swaps the product grid — re-hook cards & reveals */
  var mo = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      if (m.addedNodes.length) {
        initReveal(document);
        initStyleToggle(document);
      }
    });
  });
  var grid = document.getElementById('ProductGridContainer');
  if (grid) mo.observe(grid, { childList: true, subtree: true });

  window.AveliqInit = initAll;
})();
